import React from "react";
import CommonSelectLite from "components/Common/CommonSelectLite";
import StudentExamTypeMatrixTable from "../components/StudentExamTypeMatrixTable";
import useClassManagement from "feature-module/academic/classes/hooks/useClassManagement";
import { useTranslation } from "react-i18next";
import NoDataComponent from "components/Common/NoData";
import { ZIndexUtils } from "primereact/utils";
import { getSubjectLabelFromCode } from "utils/schoolUtils";
import PageHeader from "components/Common/PageHeader";
import { all_routes } from "router/all_routes";
import { Form } from "antd";

// type ClassItem = {
//   id: string;
//   name: string;
//   classSubjects?: Array<{ subject: { id: string; name: string } }>;
//   classSubject?: Array<{ subject: { id: string; name: string } }>;
// };

const MarkMatrix: React.FC = () => {
    const { classes } = useClassManagement();
    const [classId, setClassId] = React.useState<string>();
    const [subjectId, setSubjectId] = React.useState<string>();
    const [subjects, setSubjects] = React.useState<Array<{ id: string; name: string }>>([]);
    const [semester, setSemester] = React.useState<string>();
    const { t } = useTranslation();
    const semesterOptions = [
        { label: t("semester_1"), value: "S1" },
        { label: t("semester_2"), value: "S2" },
    ]
    React.useEffect(() => {
        if (!classId) {
            setSubjects([]);
            setSubjectId(undefined);
            return;
        }
        const cls = classes.find((c) => c.id === classId);
        const list =
            (cls?.classSubject || [])
                .map((cs: any) => cs?.subject)
                .filter((s: any): s is { id: string; name: string } => !!s?.id)
                .reduce((m: any, s: any) => m.set(s.id, s), new Map<string, { id: string; name: string }>());
        const arr = Array.from(list.values()).map((s: any) => ({ id: s.id, name: getSubjectLabelFromCode(s?.code) }));
        setSubjects(arr as any);
        // setSemester(undefined);
        if (subjectId && !arr.find((s: any) => s?.id === subjectId)) setSubjectId(undefined);
    }, [classId, classes, t]);

    const breadcrumbItems = [
        { label: "dashboard", path: all_routes.dashboard },
        { label: "mark_matrix.title", active: true },
    ];

    return (
        <div className="page-wrapper">
            <div className="content container-fluid">
                <PageHeader title={t("mark_matrix.title")} breadcrumbItems={breadcrumbItems} />

                <div className=" mb-3  gap-2">
                    <div className="card">
                        <div className="card-body" style={{ zIndex: 999 }}>
                            <div className="row">
                                <div className="col-md-4">
                                    <Form.Item label={t("class")}>
                                        <CommonSelectLite
                                            options={classes}
                                            optionLabelKey="name"
                                            optionValueKey="id"
                                            value={classId}
                                            onChange={setClassId}
                                        />
                                    </Form.Item>
                                </div>
                                <div className="col-md-4">
                                    <Form.Item label={t("subject")}>
                                        <CommonSelectLite
                                            options={subjects}
                                            optionLabelKey="name"
                                            optionValueKey="id"
                                            value={subjectId}
                                            onChange={setSubjectId}
                                            disabled={!classId || subjects.length === 0}
                                        /></Form.Item>
                                </div>

                                <div className="col-md-4">
                                    <Form.Item label={t("semester")}>
                                        <CommonSelectLite
                                            options={semesterOptions}
                                            optionLabelKey="label"
                                            optionValueKey="value"
                                            value={semester}
                                            onChange={setSemester}
                                            disabled={!classId || subjects.length === 0 || !subjectId}
                                        />
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {classId && subjectId && semester ? (
                    <StudentExamTypeMatrixTable classId={classId} subjectId={subjectId} semester={semester} />
                ) : (
                    <NoDataComponent />
                )}
            </div>
        </div>
    );
};

export default MarkMatrix;
